import { LuxLink } from "@lux/atoms/components/LuxLink";
import { useZmClientInfinite } from "@components/hooks/useZmClientInfinite";
import { ResponsiveBreakpoint } from "@utils/StyleConstants";
import { CollectionCard, CollectionLoadingCard } from "./CollectionCard";
import { range } from "@luma-team/shared";
import classNames from "classnames";

export const Collections = ({
  infinite = true,
  title,
}: {
  infinite?: boolean;
  title?: string | null | undefined;
}) => {
  const {
    data: nfts,
    loadMore,
    hasMore,
  } = useZmClientInfinite({
    path: "/solana/explore/get-nft-collections",
    args: {
      sort_column: "featured_position",
      sort_direction: "asc",
    },
  });

  return (
    <div className="collections zm-container">
      {title && <h2>{title}</h2>}

      <div className="items">
        {nfts?.length > 0 &&
          nfts.slice(0, 12).map((nft, i) => (
            <div
              key={nft.api_id}
              className={classNames({ "desktop-only": i > 5 })}
            >
              <LuxLink href={`/collection/${nft.magic_eden_symbol}`}>
                <CollectionCard info={nft} />
              </LuxLink>
            </div>
          ))}
        {(!nfts || (hasMore && infinite)) &&
          range(12).map((i) => (
            <div
              key={(nfts?.length ?? 0) + i}
              className={classNames({ "desktop-only": i > 5 })}
            >
              <CollectionLoadingCard
                loadMore={i === 0 && hasMore && infinite ? loadMore : undefined}
              />
            </div>
          ))}
      </div>

      <style jsx>{`
        .collections {
          margin: 0 auto;
          padding: 2rem var(--side-padding);

          .items {
            display: grid;
            gap: 2rem;
            grid-template-columns: 1fr 1fr 1fr 1fr;

            @media (max-width: ${ResponsiveBreakpoint.communityLargeTwoCol}) {
              grid-template-columns: 1fr 1fr 1fr;
              gap: 1.5rem;
            }

            @media (max-width: ${ResponsiveBreakpoint.medium}) {
              grid-template-columns: 1fr 1fr;
            }

            @media (max-width: ${ResponsiveBreakpoint.tiny}) {
              grid-template-columns: 1fr;
            }
          }
        }

        .desktop-only {
          @media (max-width: ${ResponsiveBreakpoint.medium}) {
            display: none;
          }
        }
      `}</style>
    </div>
  );
};
